import { styled } from '@mui/material';
import { tooltipClasses, Tooltip as TooltipMaterial } from '@mui/material';

const getVariationStyles = (theme, variation) => {
  switch (variation) {
    case 'default':
      return {
        [`& .${tooltipClasses.arrow}`]: {
          color: '#646463',
        },
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.black,
        },
        '& .MuiTooltip-tooltip': {
          backgroundColor: '#646463',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '14px',
          padding: '8px 12px',
        },
      };
    case 'error':
      return {
        [`& .${tooltipClasses.arrow}`]: {
          color: 'orange',
        },
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.black,
        },
        '& .MuiTooltip-tooltip': {
          backgroundColor: 'orange',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '14px',
          padding: '8px 12px',
        },
      };
    case 'warning':
      return {
        [`& .${tooltipClasses.arrow}`]: {
          color: 'orange',
        },
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.black,
        },
        '& .MuiTooltip-tooltip': {
          backgroundColor: 'orange',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '14px',
          padding: '8px 12px',
        },
      };
    default:
      return {
        [`& .${tooltipClasses.arrow}`]: {
          color: 'orange',
        },
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.black,
        },
        '& .MuiTooltip-tooltip': {
          backgroundColor: 'orange',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '14px',
          padding: '8px 12px',
        },
      };
  }
};

const MaterialTooltip = ({ variation = 'default', ...props }) => {
  const Tooltip = styled(({ className, ...props }) => (
    <TooltipMaterial {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => getVariationStyles(theme, variation));
  return <Tooltip {...props}>{props.children}</Tooltip>;
};

export default MaterialTooltip;
